<template>
  <div class="video-monitor">
    <div class="video-monitor-title">
      <span class="title">视频监控</span>
    </div>
    <Carousel
      v-model="swiperNum"
      :arrow="videoList.length > 1 ? 'hover' : 'never'"
    >
      <CarouselItem
        v-for="(item, index) in videoList"
        :key="index"
        :style="{ height: videoH - 60 + 'px' }"
      >
        <div class="video-box" :style="videoContainerStyle">
          <videoPlays
            :httpUrl="item.hlsAddr"
            :videoDeviceId="item.id"
            v-if="item.hlsAddr"
            :height="videoH - 80"
            :width="videoW - 20"
            :showClose="false"
            videoid="2"
          />
        </div>
      </CarouselItem>
    </Carousel>
  </div>
</template>

<script>
import videoPlays from "../../videoPlay/videoPlays.vue";

export default {
  name: "VideoMonitor",
  components: {
    videoPlays,
  },
  props: {
    videoH: {
      type: Number,
      required: true,
    },
    videoW: {
      type: Number,
      required: true,
    },
    moduleId: {
      moduleId: String | Number,
      required: true,
    },
  },
  data() {
    return {
      swiperNum: 0,
      videoList: [],
    };
  },
  computed: {
    videoContainerStyle() {
      return {
        width: this.videoW + "px",
        height: this.videoH - 80 + "px",
      };
    },
  },
  mounted() {
    this.getVideoList();
  },
  methods: {
    async getVideoList() {
      try {
        this.videoList = [];
        const response = await this.$Axios({
          url: `/mcbw/fire_control_hosts/${this.moduleId}`,
          // url: `/mcbw/fire_control_hosts/4134`,
          type: "get",
          obj: {},
        });
        console.log("responseresponseresponse", response);
        this.videoList.push(response.data.data.camera);
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
  },
};
</script>

<style scoped lang="less">
.video-monitor {
  .video-monitor-title {
    margin-bottom: 10px;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/remote-control/components/VideoMonitor.vue